/**
 * Extract flattened field data from nested objects
 * Supports both flattened keys (e.g., 'metadata.confidence_score') and nested objects
 */
export function extractFlattenedField(
  data: any,
  fieldPath: string,
  fallback: any = null
): any {
  if (!data || typeof data !== "object") return fallback;

  // Try direct flattened field access first (e.g., data['metadata.confidence_score'])
  if (data[fieldPath] !== undefined && data[fieldPath] !== null) {
    return data[fieldPath];
  }

  // Try nested object access as fallback (e.g., data.metadata.confidence_score)
  const pathParts = fieldPath.split(".");
  let current = data;

  for (const part of pathParts) {
    if (current && typeof current === "object" && current[part] !== undefined) {
      current = current[part];
    } else {
      return fallback;
    }
  }

  return current !== undefined ? current : fallback;
}
